module.exports = __webpack_public_path__ + "img/userAvatar.f586f874.png";